export default __webpack_public_path__ + "8a1f03d7b24ff38543e9abe318f13f33.png";